import tuataraLogo from "../../assets/png/tuataraLogo.png";
const Inspiration = () => {
  return (
    <>
      <div className="custom-container pb-[80px]">
        <div className="grid grid-cols-1 lg:grid-cols-8">
          <div className="lg:col-span-2 col-span-1">
            <img src={tuataraLogo} alt="" className="md:py-[199px] sm:py-[50px] py-[10px]" />
          </div>
          <div className="lg:col-span-6 col-span-1 sm:pt-[63px] pt-[40px] md:pl-[80px] pl-[0px] w-[-webkit-fill-available]">
            <div className="flex 2xl:text-[36px] 2xl:text-[46px] xl:text-[40px] lg:text-[35px] text-[23px] text-[16px] text-[#000] text-[Roboto] font-bold py-[38px]">
              <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
                INSPIRATION & B
                <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
                  ACKSTORY
                </span>
              </span>
            </div>
            <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
              Our logo is inspired by New Zealand’s native and iconic Tuatara, the last surviving reptile that thrived
              in the Mesozoic Era of the dinosaurs.
              <br />
              <br />
              Just like the tuatara reptile— an ancient survivor of the dinosaur age known for its remarkable 100+ year
              lifespan— The TUATARA Utility Vehicle is built to evolve, endure and thrive in tough terrains.
              <br />
              <br />
              The Tuatara is a master of its environment, evolving rapidly to be a best in-class utility vehicle,
              engineered from solid steel to outlast the ordinary.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Inspiration;
